export const iconFontAwesomeMapsMapPin = (
	<i className="fa-solid fa-map-pin"></i>
);
